import { useAsync } from '@flowwai-frontend/shared/common-components'

import {
   SsoExchangeRequestType,
   SsoExchangeResponseType
} from '../../services/types'
import { useSsoExchangeService } from '../services/useSsoExchangeService'

const useSsoExchangeAPI = () => {
   const ssoExchangeService = useSsoExchangeService()

   const {
      triggerAsyncAPI: ssoExchangeAPI,
      apiStatus: ssoExchangeAPIStatus,
      error: ssoExchangeAPIError
   } = useAsync<
      SsoExchangeResponseType | unknown,
      Error,
      SsoExchangeRequestType
   >(ssoExchangeService.exchangeSsoCode)

   return {
      ssoExchangeAPI,
      ssoExchangeAPIStatus,
      ssoExchangeAPIError
   }
}

export { useSsoExchangeAPI }
